import { IUpdateEntradaPUseCase } from "../../../presentation/useCases/update/update_entrada_produtos_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class UpdateEntradaPUseCase implements IUpdateEntradaPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async updateEntradaP(IdEntradaProduto: number, Data: Date | null, IdCentroCusto: number | null, IdProdutoServico: number | null, NroNotaFiscal: string | null, Quantidade: number | null, IdFornecedor: number | null, IdOrdemCompraProduto: number | null, NrNotaFiscal: string | null, IdSessaoMultipla: string | null, ValorUnitario: number | null): Promise<void> {
    
    await this.repository.updateEntradaP(IdEntradaProduto, Data, IdCentroCusto, IdProdutoServico, NroNotaFiscal, Quantidade, IdFornecedor, IdOrdemCompraProduto, NrNotaFiscal, IdSessaoMultipla, ValorUnitario
    );
  }
}
